var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAvailable)?_c('button',{staticClass:"o-tab-btn",class:[_vm.tab.config.UIClass,
     { 'o-tab-btn--active': _vm.isCurrentTab }],on:{"click":function($event){return _vm.tab.show(true)}}},[_vm._v(" "+_vm._s(_vm.tabName)+" "),(_vm.hasNotification)?_c('div',{staticClass:"fas fa-circle-exclamation l-notification-icon"}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }